import { CartAddEvent } from '@theme/events';

const FEE_VARIANT_ID = 48257558741145;
const MAX_BYTES = 10 * 1024 * 1024;
const OK_TYPES = ['image/png', 'image/jpeg', 'application/pdf'];

class CorusEmbroidery extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    if (!this.querySelector('[data-emb="toggle"]')) return;
    this._init = true;

    const q = (s) => this.querySelector(s);
    this.q = q;
    this.on = false;
    this.logoOn = false;
    this.size = 16;
    this.color = '#ffffff';
    this.colorName = 'White';
    this.font = '';
    this.fontName = '';
    this.placement = '';
    this.pending = null;
    this.drag = false;

    this.toggle = q('[data-emb="toggle"]');
    this.fields = q('[data-emb="fields"]');
    this.previewWrap = q('[data-emb="previewwrap"]');
    this.inName = q('[data-emb="name"]');
    this.inCred = q('[data-emb="cred"]');
    this.inThread = q('[data-emb="thread"]');
    this.inFont = q('[data-emb="font"]');
    this.inLogoFlag = q('[data-emb="logoflag"]');
    this.inPlacement = q('[data-emb="placement"]');
    this.inComments = q('[data-emb="comments"]');
    this.inFile = q('[data-emb="file"]');
    this.inFlag = q('[data-emb="flag"]');
    this.inGroup = q('[data-emb="group"]');
    this.inOther = q('[data-emb="other"]');
    this.errorEl = q('[data-emb="error"]');
    this.sizer = q('[data-emb="sizer"]');
    this.sizeout = q('[data-emb="sizeout"]');
    this.logoToggle = q('[data-emb="logo"]');
    this.logoPanel = q('[data-emb="logopanel"]');
    this.otherWrap = q('[data-emb="otherwrap"]');
    this.logobox = q('[data-emb="logobox"]');
    this.stage = q('[data-emb="stage"]');
    this.ov = q('[data-emb="ov"]');
    this.colname = q('[data-emb="colname"]');
    this.fontname = q('[data-emb="fontname"]');
    this.filename = q('[data-emb="filename"]');

    this.props = [this.inName, this.inCred, this.inThread, this.inFont, this.inLogoFlag, this.inPlacement, this.inComments, this.inFile, this.inFlag, this.inGroup];
    this.form = (this.inName && this.inName.form) || document.querySelector('product-form-component form');

    this.placeMap = { 'Right chest': [37, 40], 'Left chest': [63, 40], 'Right sleeve': [17, 43], 'Left sleeve': [83, 43], 'Other': [50, 47] };
    this.namePlaceMap = { pocket: [68, 38], opposite: [32, 38] };

    this.setEnabled(false);

    this.toggle.addEventListener('change', () => this.setOn(this.toggle.checked));
    this.logoToggle.addEventListener('change', () => this.setLogo(this.logoToggle.checked));
    this.inName.addEventListener('input', () => this.render());
    this.inCred.addEventListener('input', () => this.render());
    this.inFile.addEventListener('change', () => this.onFile());
    this.sizer.addEventListener('input', () => this.setSize(Number(this.sizer.value)));

    this.swatches = Array.prototype.slice.call(this.querySelectorAll('[data-swatch]'));
    this.swatches.forEach((b) => b.addEventListener('click', () => this.pickColor(b)));
    const white = this.querySelector('[data-swatch="#ffffff"]') || this.swatches[1];
    if (white) this.pickColor(white);

    this.fontButtons = Array.prototype.slice.call(this.querySelectorAll('[data-font]'));
    this.fontButtons.forEach((b) => b.addEventListener('click', () => this.pickFont(b)));
    if (this.fontButtons[0]) this.pickFont(this.fontButtons[0]);

    this.placeButtons = Array.prototype.slice.call(this.querySelectorAll('[data-v]'));
    this.placeButtons.forEach((b) => b.addEventListener('click', () => this.pickPlace(b)));
    if (this.inOther) this.inOther.addEventListener('input', () => { if (this.placement === 'Other') this.inPlacement.value = 'Other — ' + this.inOther.value.trim(); });

    this.namePlaceButtons = Array.prototype.slice.call(this.querySelectorAll('[data-pos]'));
    this.namePlaceButtons.forEach((b) => b.addEventListener('click', () => this.pickNamePos(b)));

    this.enableDrag();

    if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e), true);
    document.addEventListener(CartAddEvent.eventName, (e) => this.afterAdd(e));

    this.render();
  }

  setEnabled(state) { this.props.forEach((el) => { if (el) el.disabled = !state; }); }

  setOn(on) {
    this.on = on;
    this.fields.hidden = !on;
    if (this.previewWrap) this.previewWrap.hidden = !on;
    this.setEnabled(on);
    if (this.inFlag) this.inFlag.value = 'Yes';
    if (this.inLogoFlag) this.inLogoFlag.value = this.logoOn ? 'Yes' : 'No';
    if (!on) this.clearErr();
    this.render();
  }

  setLogo(on) {
    this.logoOn = on;
    this.logoPanel.hidden = !on;
    if (this.inLogoFlag) this.inLogoFlag.value = on ? 'Yes' : 'No';
    if (!on) {
      this.placement = '';
      if (this.inPlacement) this.inPlacement.value = '';
      this.placeButtons.forEach((b) => b.removeAttribute('data-on'));
      if (this.otherWrap) this.otherWrap.hidden = true;
      if (this.inFile) this.inFile.value = '';
      if (this.filename) this.filename.textContent = 'No file chosen';
      if (this.logobox) { this.logobox.hidden = true; this.logobox.style.backgroundImage = ''; this.logobox.textContent = 'logo'; }
    }
    this.positionBox();
  }

  pickColor(b) {
    this.swatches.forEach((x) => x.removeAttribute('data-on'));
    b.setAttribute('data-on', '1');
    this.color = b.dataset.swatch;
    this.colorName = b.dataset.name;
    if (this.inThread) this.inThread.value = this.colorName;
    if (this.colname) this.colname.textContent = ' · ' + this.colorName;
    this.render();
  }

  pickFont(b) {
    this.fontButtons.forEach((x) => x.removeAttribute('data-on'));
    b.setAttribute('data-on', '1');
    this.font = b.dataset.font;
    this.fontName = b.dataset.name;
    if (this.inFont) this.inFont.value = this.fontName;
    if (this.fontname) this.fontname.textContent = ' · ' + this.fontName;
    this.render();
  }

  pickPlace(b) {
    this.placeButtons.forEach((x) => x.removeAttribute('data-on'));
    b.setAttribute('data-on', '1');
    this.placement = b.dataset.v;
    if (this.otherWrap) this.otherWrap.hidden = this.placement !== 'Other';
    if (this.inPlacement) this.inPlacement.value = this.placement === 'Other' ? ('Other — ' + (this.inOther.value || '').trim()) : this.placement;
    this.positionBox();
  }

  pickNamePos(b) {
    if (!this.ov) return;
    const p = this.namePlaceMap[b.dataset.pos];
    if (!p) return;
    this.ov.style.left = p[0] + '%';
    this.ov.style.top = p[1] + '%';
  }

  positionBox() {
    if (!this.logobox) return;
    if (!this.logoOn || !this.placement) { this.logobox.hidden = true; return; }
    const p = this.placeMap[this.placement] || [50, 47];
    this.logobox.style.left = p[0] + '%';
    this.logobox.style.top = p[1] + '%';
    this.logobox.hidden = false;
  }

  setSize(v) { v = Math.round(v); this.size = v; this.sizeout.textContent = v + 'px'; this.render(); }

  onFile() {
    const f = this.inFile.files && this.inFile.files[0];
    if (!f) { if (this.filename) this.filename.textContent = 'No file chosen'; this.setLogoPreview(false); return; }
    const ok = OK_TYPES.indexOf(f.type) !== -1 || /\.(png|jpe?g|pdf)$/i.test(f.name);
    if (!ok) { this.err('Logo must be a PNG, JPG, or PDF file.'); this.inFile.value = ''; if (this.filename) this.filename.textContent = 'No file chosen'; this.setLogoPreview(false); return; }
    if (f.size > MAX_BYTES) { this.err('Logo must be 10 MB or smaller.'); this.inFile.value = ''; if (this.filename) this.filename.textContent = 'No file chosen'; this.setLogoPreview(false); return; }
    this.clearErr();
    if (this.filename) this.filename.textContent = f.name;
    this.setLogoPreview(true, f);
  }

  setLogoPreview(has, file) {
    if (!this.logobox) return;
    if (has && file && /^image\//.test(file.type)) { this.logobox.style.backgroundImage = 'url(' + URL.createObjectURL(file) + ')'; this.logobox.textContent = ''; }
    else if (has) { this.logobox.style.backgroundImage = ''; this.logobox.textContent = 'PDF'; }
    else { this.logobox.style.backgroundImage = ''; this.logobox.textContent = 'logo'; }
  }

  enableDrag() {
    const ov = this.ov, stage = this.stage;
    if (!ov || !stage) return;
    ov.style.touchAction = 'none';
    ov.addEventListener('pointerdown', (e) => { this.drag = true; try { ov.setPointerCapture(e.pointerId); } catch (x) {} ov.style.cursor = 'grabbing'; });
    ov.addEventListener('pointerup', () => { this.drag = false; ov.style.cursor = 'grab'; });
    ov.addEventListener('pointermove', (e) => {
      if (!this.drag) return;
      const r = stage.getBoundingClientRect();
      let x = (e.clientX - r.left) / r.width * 100;
      let y = (e.clientY - r.top) / r.height * 100;
      x = Math.max(8, Math.min(92, x));
      y = Math.max(12, Math.min(88, y));
      ov.style.left = x + '%';
      ov.style.top = y + '%';
    });
  }

  render() {
    const nm = (this.inName.value || '').toUpperCase();
    const cr = (this.inCred.value || '').toUpperCase();
    const n = this.q('[data-emb="ovname"]');
    const c = this.q('[data-emb="ovcred"]');
    if (n) { n.textContent = nm; n.style.color = this.color; n.style.fontSize = this.size + 'px'; n.style.fontFamily = this.font; }
    if (c) { c.textContent = cr; c.style.color = this.color; c.style.fontSize = Math.round(this.size * 0.6) + 'px'; c.style.fontFamily = this.font; }
  }

  err(m) { if (this.errorEl) { this.errorEl.textContent = m; this.errorEl.hidden = false; } }
  clearErr() { if (this.errorEl) { this.errorEl.hidden = true; } }

  onSubmit(e) {
    if (!this.on) return;
    if (!this.inName.value.trim()) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Please enter the embroidered name.'); this.inName.focus(); return; }
    if (!this.colorName) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Please choose a thread colour.'); return; }
    if (this.logoOn) {
      const f = this.inFile.files && this.inFile.files[0];
      if (!f) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Please upload your logo file.'); return; }
      if (f.size > MAX_BYTES) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Logo must be 10 MB or smaller.'); return; }
      if (!this.placement) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Please choose where the logo goes.'); return; }
      if (this.placement === 'Other' && !this.inOther.value.trim()) { e.preventDefault(); e.stopImmediatePropagation(); this.err('Please specify the logo placement.'); return; }
    }
    this.clearErr();
    if (this.inThread) this.inThread.value = this.colorName;
    if (this.inFont) this.inFont.value = this.fontName;
    if (this.inLogoFlag) this.inLogoFlag.value = this.logoOn ? 'Yes' : 'No';
    if (this.logoOn && this.inPlacement) this.inPlacement.value = this.placement === 'Other' ? ('Other — ' + this.inOther.value.trim()) : this.placement;
    this.inCred.disabled = !this.inCred.value.trim();
    this.inComments.disabled = !this.inComments.value.trim();
    this.inFile.disabled = !this.logoOn;
    this.inPlacement.disabled = !this.logoOn;
    const gid = 'emb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    if (this.inGroup) this.inGroup.value = gid;
    this.pending = { group: gid };
  }

  async afterAdd(e) {
    if (!this.pending) return;
    const data = (e.detail && e.detail.data) || {};
    if (data.source && data.source !== 'product-form-component') return;
    if (data.didError) { this.pending = null; return; }
    const group = this.pending.group;
    this.pending = null;
    const qty = Number(data.itemCount) || 1;
    try {
      const ids = Array.prototype.slice.call(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean).join(',');
      const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: FEE_VARIANT_ID, quantity: qty, properties: { _embroidery_group: group } }], sections: ids })
      });
      const out = await res.json();
      if (out.status) return;
      let cart = null;
      try { cart = await (await fetch('/cart.js')).json(); } catch (x) {}
      document.dispatchEvent(new CartAddEvent(cart || undefined, 'corus-embroidery-fee', { source: 'corus-embroidery', itemCount: qty, sections: out.sections }));
    } catch (err) { console.error('Embroidery fee add failed', err); }
  }
}

if (!customElements.get('corus-embroidery-component')) {
  customElements.define('corus-embroidery-component', CorusEmbroidery);
}
